import { RatioBarComposition, RatioBarLine } from '@talend/design-system';

import { RatioBar } from './RatioBar.component';

export { RatioBarComposition, RatioBarLine };

export default RatioBar;
